<template>
  <div>
    <div class="mb-6" v-html="$t('invitation.text')" />
    <div :class="{ 'grey rounded-lg pa-4': $vuetify.breakpoint.smAndDown }">
      <div
        v-for="(item, index) in $t('invitation.list', { returnObjects: true })"
        :key="index"
        class="d-flex align-center"
        :class="{ 'pb-4': index < $t('invitation.list', { returnObjects: true }).length - 1 }"
      >
        <div class="mr-4">
          <v-img width="40" height="40" contain :src="$asset(`img/icons/${item.icon}.svg`)" />
        </div>
        <div class="py-0 text-left">{{ item.text }}</div>
      </div>
    </div>
    <div class="d-flex align-end">
      <div class="flex-grow-1">
        <label class="mb-2 mt-6" for="shareLink">{{ $t('invitation.shareLink') }}</label>
        <v-text-field
          id="shareLink"
          v-model="shareLink"
          data-cy="invitationContentShareLink"
          solo
          flat
          hide-details
          readonly
          class="shareLink"
          @click.prevent="inputClick"
        />
      </div>
      <ShareButton
        event="invitation"
        :url="shareLink"
        :title="$t('invitation.shareTitle')"
        :text="shareText"
        share-button-data-cy="invitationContentShareButton"
      />
    </div>
    <SendButton
      v-if="!$vuetify.breakpoint.smAndDown"
      :loading="false"
      :success-state="codeCopied"
      :button-text="$t('invitation.copyCode')"
      :button-text-success="$t('invitation.codeCopied')"
      block
      class="mt-6"
      @reset="codeCopied = false"
      @click="copyCode"
    />
    <template v-if="invitedFamily.length">
      <div class="lineTitle text-center my-6 grey-darken-1--text">
        <span>
          {{ $t('invitation.familyTitle') }}
        </span>
      </div>
      <div
        v-for="(member, index) in invitedFamily"
        :key="`family_${index}`"
        :class="{ 'mb-6': index < invitedFamily.length - 1 }"
      >
        <div class="text-h3">
          {{ member.name ? member.name : $t('invitation.emptyMemberName') }}
        </div>
        <div
          data-cy="invitationContentFamilyMemberEmail"
          class="text-body-small grey-darken-1--text"
        >
          {{ member.email }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import invitation from '@/mixins/invitation';
import SendButton from '@/components/Forms/Parts/SendButton';
import ShareButton from '@/components/Atoms/ShareButton.vue';

export default {
  name: 'InvitationContent',
  components: { ShareButton, SendButton },
  mixins: [invitation],
  computed: {
    ...mapGetters({
      shareLink: 'profile/invitation/shareLink'
    }),
    invitedFamily() {
      if (
        this.$auth.user.invitation.invitedUsers &&
        this.$auth.user.invitation.invitedUsers.length
      ) {
        return this.$auth.user.invitation.invitedUsers.map(invUser => ({
          ...invUser,
          name: ((invUser.firstName || '') + ' ' + (invUser.lastName || '')).trim()
        }));
      }
      return [];
    },
    shareText() {
      const name =
        this.$auth.user.firstName || this.$auth.user.lastName
          ? ((this.$auth.user.firstName || '') + ' ' + (this.$auth.user.lastName || '')).trim()
          : this.$auth.user.email;
      return this.$t('invitation.shareText', { personName: name });
    }
  },
  mounted() {
    this.codeCopied = false;
    this.toggleWebChat('none');
  },
  destroyed() {
    this.toggleWebChat('block');
  },
  methods: {
    inputClick(evt) {
      evt.preventDefault();
      this.gtmPush({ event: 'invitation', 'event.detail': 'input_click' });
      this.$nextTick(() => {
        document.getElementById('shareLink').select();
      });
      this.copyCode();
    }
  }
};
</script>

<style lang="scss" scoped>
.shareLink {
  ::v-deep {
    .v-input__slot {
      border-color: $primary !important;
      background-color: $brand-lighten !important;
    }

    input {
      color: $primary !important;
    }
  }
}

.lineTitle {
  overflow: hidden;

  span {
    display: inline-block;
    position: relative;

    &:before,
    &:after {
      content: '';
      position: absolute;
      height: 1px;
      border-bottom: 1px solid $grey-lighten;
      top: 50%;
      width: 600px;
    }

    &:before {
      right: 100%;
      margin-right: 16px;
    }

    &:after {
      left: 100%;
      margin-left: 16px;
    }
  }
}
</style>
